function formDatePicker() {
    jQuery('[data-toggle="datepicker"]').each((index, element) => {
        const datepickerTrigger = jQuery(element).parent().find('.datepicker-trigger');

        jQuery(element).datepicker({
            trigger: datepickerTrigger,
            monthsShort: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            daysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            template: '<div class="datepicker-container"><div class="datepicker-panel" data-view="days picker"><ul><li data-view="month prev">&lsaquo;</li><li data-view="month current"></li><li data-view="month next">&rsaquo;</li></ul><ul data-view="week"></ul><ul data-view="days"></ul></div></div>'
        });
    });
}

export default formDatePicker;
